import { render } from "./switch_From.vue?vue&type=template&id=2d5de0da"
import script from "./switch_From.vue?vue&type=script&lang=js"
export * from "./switch_From.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__